import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { logError } from "../../lib/logError";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const { googleSession } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const m = (window.location.hash || "").match(/session_id=([^&]+)/);
    (async () => {
      if (m) { try { await googleSession(decodeURIComponent(m[1])); } catch (e) { logError("auth.googleSession", e); } }
      window.history.replaceState(null, "", window.location.pathname);
      nav("/track", { replace: true });
    })();
  }, [googleSession, nav]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="font-mono-x text-primary tracking-[0.3em] text-sm animate-pulse">SIGNING YOU IN…</div>
    </div>
  );
}
